import React from "react";
import { Sparkles } from "lucide-react";

const AiPrompt = ({ prompt, text, getChat }) => {
  const handleClick = () => {
    getChat(prompt);
  };
  return (
    <div
      className="flex items-center gap-1.5 rounded-3xl px-3.5 py-1.5 border-gray-200 dark:border-gray-800 border bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700 w-fit cursor-pointer transition-colors"
      onClick={handleClick}
    >
      <Sparkles size={14} className="text-secondary dark:text-secondary-light shrink-0" />
      <span className="text-[0.735rem] leading-[18px] font-normal text-nowrap text-gray-700 dark:text-gray-200">
        {text}
      </span>
    </div>
  );
};

export default AiPrompt;
